/**
 * Route helpers for the Nations League hub.
 *
 * The hub owns six URLs total — overview + five sub-pages — all under
 * `/football/competitions/nationsleague`. This module is the single source of
 * truth for the section slugs, the URL builder, and the page-variant registry.
 */

export type NationsLeagueSection = "news" | "videos" | "standings" | "matches" | "teams";

export const NL_SECTIONS: NationsLeagueSection[] = ["news", "videos", "standings", "matches", "teams"];

export const NL_HUB_BASE = "/football/competitions/nationsleague";

/**
 * Build a hub URL (path only — locale prefix goes on top via `buildLocalePath`).
 * No `section` → overview (`/football/competitions/nationsleague`).
 */
export function hubUrl(section?: NationsLeagueSection): string {
    return section ? `${NL_HUB_BASE}/${section}` : NL_HUB_BASE;
}
